import * as Diagram from "../../../../components/diagram";

const levelColumns = [
  {
    key: "醫師報告",
    isNumber: true,
    isSum: true,
    isControl: true,
  },
  {
    key: "案件狀態",
    isNumber: true,
  },
];

export const CareVillageToDoctorReport = {
  label: "照護鄉鎮 vs 醫師報告",
  key: "CareVillageToDoctorReport",
  path: "AtriumFibrillation/CareVillageToDoctorReport",
  api: "TCS_V_HeartSS01",
  render: (options) => (
    <Diagram.AtriumFibrillation.CareVillageToDoctorReport {...options} />
  ),
  isColSum: true,
  isRowSum: true,
  isGroup: true,
  groupColumns: [
    {
      key: "照護鄉鎮",
      field: "照護鄉鎮",
      header: "",
    },
  ],
  filterColumns: [
    { key: "篩檢日期", type: "date" },
    { key: "匯入日期", type: "date" },
    { key: "案件狀態", type: "string" },
  ],
  dateRangeColumns: [
    { label: "篩檢日期", key: "篩檢日期" },
    { label: "匯入日期", key: "匯入日期" },
  ],
  levelColumns,
  columns: [],
};
